/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Gallery from 'react-grid-gallery';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Breadcrumb from '../../../components/Breadcrumb';
import Sidebar from '../../../components/Sidebar/AboutUs';
import s from '../AboutUs.css';

class FactoryPlants extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    images1: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
    images2: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
    images3: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
  };

  static defaultProps = {
    images1: [
      {
        src: '/images/factory-plants/factory-site.png',
        thumbnail: '/images/factory-plants/factory-site.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 595,
        caption: 'Factory Site',
        thumbnailCaption: 'Factory Site',
      },
    ],
    images2: [
      {
        src: '/images/factory-plants/high-quality-german-extrusion-system.png',
        thumbnail:
          '/images/factory-plants/high-quality-german-extrusion-system.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'High Quality German Extrusion System',
        thumbnailCaption: 'High Quality German Extrusion System',
      },
      {
        src: '/images/factory-plants/auto-setting-system.png',
        thumbnail: '/images/factory-plants/auto-setting-system.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'Auto Setting System',
        thumbnailCaption: 'Auto Setting System',
      },
      {
        src: '/images/factory-plants/dryer.png',
        thumbnail: '/images/factory-plants/dryer.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'Dryer',
        thumbnailCaption: 'Dryer',
      },
      {
        src: '/images/factory-plants/tunnel-kiln.png',
        thumbnail: '/images/factory-plants/tunnel-kiln.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'Tunnel Kiln',
        thumbnailCaption: 'Tunnel Kiln',
      },
      {
        src: '/images/factory-plants/high-quality-sawdust-firing-system.png',
        thumbnail:
          '/images/factory-plants/high-quality-sawdust-firing-system.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'High Quality Sawdust Firing System',
        thumbnailCaption: 'High Quality Sawdust Firing System',
      },
      {
        src:
          '/images/factory-plants/auto-staking-system-for-finished-products.png',
        thumbnail:
          '/images/factory-plants/auto-staking-system-for-finished-products.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'Auto Staking System for Finished Products',
        thumbnailCaption: 'Auto Staking System for Finished Products',
      },
    ],
    images3: [
      {
        src: '/images/factory-plants/auto-packing-machine.png',
        thumbnail: '/images/factory-plants/auto-packing-machine.png',
        thumbnailWidth: 432,
        thumbnailHeight: 532,
        caption: 'Auto Packing Machine',
        thumbnailCaption: 'Auto Packing Machine',
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      images1: this.props.images1,
      images2: this.props.images2,
      images3: this.props.images3,
    };
  }

  render() {
    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <Sidebar title={this.props.title} />
          <div className={s.contents}>
            <h1>
              {this.props.title}
            </h1>
            <p>
              Maybricks factory built up area consists of 10 acres which are
              divided into 2 plants: Plant 1 and Plant 2. Both plants contribute
              to the total production of 300,000 pieces per day. With more than
              30 years of experience in brick making industry, we are a group of
              brick makers with strong R&amp;D capabilities. Our products are
              produced under the most stringent quality control to serve the
              needs and requirements of current market environment, governing
              bodies, legislation and regulations.
            </p>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images1}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={494}
              />
            </div>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images2}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={247}
              />
            </div>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images3}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={394}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(FactoryPlants);



// WEBPACK FOOTER //
// ./src/routes/about-us/factory-plants/FactoryPlants.js